import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React, { useState } from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useSelector } from 'react-redux';
import './style.scss';

interface Props {
    quizName: string;
    onExited?: () => void;
}

const AutoExecuteInfoModal: React.FC<Props> = (props: Props) => {
    const { quizName, onExited } = props;
    const [show, setShow] = useState<boolean>(true);

    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const handleUnderstand = () => {
        setShow(false);
    };

    return (
        <Modal backdrop="static" centered className="auto-execute-info-modal" keyboard={false} onExited={onExited} show={show}>
            <Modal.Body>
                <div className="container">
                    <i className="material-icons-outlined align-middle icon">{Constants.icons.REPORT_PROBLEM}</i>
                    <p className="title">{strings.ATTENTION}</p>
                    <p className="content">{strings.YOU_ALREADY_HAVE_A_TEST_AUTOMATICALLY_OPENING_IN_THE_APPLICATION}</p>
                    <p className="content box">{quizName}</p>
                    <p className="content">{strings.ONLY_ONE_TEST_CAN_BE_OPENED_AUTOMATICALLY_AT_A_TIME}</p>

                    <div className="buttons">
                        <button className="btn btn-block right" onClick={handleUnderstand} type="button">
                            {strings.UNDERSTAND}
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AutoExecuteInfoModal;
